import { useAccess } from "./useAccess";

export const permissionName = "CMS";

//PERMISSION NAME ITEMS
export const permissionIsAccessCMSCareer = "AccessCareer";
export const permissionIsAccessCMSOverview = "AccessCMSOverview";
export const permissionIsAccessCMSContent = "AccessContent";
export const permissionIsAccessCMSMedia = "AccessMedia";
export const permissionIsAccessCMSInbox = "AccessInbox";
export const permissionIsAccessCMSNotification = "AccessCMSNotification";
export const permissionIsAccessCMSSetting = "AccessCMSSetting";
export const permissionIsAccessCMSAnnouncement = "AccessAnnouncement";
export const permissionIsAccessCMSWorkflow = "AccessWorkflow"

export const groupPermissionAccessCMSCareer = {
    view: () => useAccess(permissionName, permissionIsAccessCMSCareer, ["view-only"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSCareer, ["delete"]),
    create: () => useAccess(permissionName, permissionIsAccessCMSCareer, ["create"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSCareer, ["update"])
}

export const groupPermissionAccessCMSOverview = {
    view: () => useAccess(permissionName, permissionIsAccessCMSOverview, ["view-only"])
}

export const groupPermissionAccessContent = {
    view: () => useAccess(permissionName, permissionIsAccessCMSContent, ["view-only"]),
    create: () => useAccess(permissionName, permissionIsAccessCMSContent, ["create"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSContent, ["update"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSContent, ["delete"]),
}

export const groupPermissionAccessMedia = {
    view: () => useAccess(permissionName, permissionIsAccessCMSMedia, ["view-only"]),
    create: () => useAccess(permissionName, permissionIsAccessCMSMedia, ["create"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSMedia, ["update"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSMedia, ["delete"]),
}

export const groupPermissionAccessInbox = {
    view: () => useAccess(permissionName, permissionIsAccessCMSInbox, ["view-only"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSInbox, ["delete"]),
}

export const groupPermissionAccessCMSNotification = {
    view: () => useAccess(permissionName, permissionIsAccessCMSNotification, ["view-only"]),
}

export const groupPermissionAccessCMSSetting = {
    view: () => useAccess(permissionName, permissionIsAccessCMSSetting, ["view-only"]),
    create: () => useAccess(permissionName, permissionIsAccessCMSSetting, ["create"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSSetting, ["update"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSSetting, ["delete"]),
}

export const groupPermissionAccessAnnouncement = {
    view: () => useAccess(permissionName, permissionIsAccessCMSAnnouncement, ["view-only"]),
    create: () => useAccess(permissionName, permissionIsAccessCMSAnnouncement, ["create"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSAnnouncement, ["update"]),
    delete: () => useAccess(permissionName, permissionIsAccessCMSAnnouncement, ["delete"]),
}

export const groupPermissionAccessWorkflow = {
    view: () => useAccess(permissionName, permissionIsAccessCMSWorkflow, ["view-only"]),
    update: () => useAccess(permissionName, permissionIsAccessCMSWorkflow, ["update"]),
}